module.exports = __webpack_public_path__ + "static/devbcn-f3a36ce7a78d426e63649781e6ea2e65.png";